import { render, staticRenderFns } from "./IconQuestionSquare.vue?vue&type=template&id=728e7325&scoped=true&"
import script from "./IconQuestionSquare.vue?vue&type=script&lang=js&"
export * from "./IconQuestionSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728e7325",
  null
  
)

export default component.exports